/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ApproveResponse,
  BootstrapResponse,
  ContainerGraphTraversalResponse,
  ContainerLayeredBackfillResponse,
  CreateIncidentInvestigationLockRequest,
  CreateInvestigationLockRequest,
  DeduplicationRequest,
  DeduplicationResponse,
  DeprecateRequest,
  FullDeduplicationRequest,
  GoldenRecordResponse,
  GoldenRecordsResponse,
  IdentityClusterResponse,
  InvestigationLockReleaseByIncidentResponse,
  InvestigationLockResponse,
  MdmBootstrapFieldMismatchRemediateRequest,
  MdmBootstrapFieldMismatchRemediateResultDto,
  MdmBootstrapFieldMismatchReportDto,
  MdmDuplicateCandidateFiltersResponse,
  MdmDuplicateCandidatesListResponse,
  MdmMatchPreviewRequest,
  MdmMatchPreviewResponse,
  MdmMatchingPolicyDetailDto,
  MdmMatchingPolicyImpactPreviewDto,
  MdmMatchingPolicyListResponse,
  MdmPolicyRematchJobRequest,
  MdmPolicyRematchJobResultDto,
  MdmPreviewEntitySearchResponse,
  MergeEventsResponse,
  MergeGoldenRecordsRequest,
  OperationalGoldenLinkBackfillRequest,
  OperationalGoldenLinkBackfillResponse,
  RejectRequest,
  RejectResponse,
  SaveMdmMatchingPolicyRequest,
  SplitRequest,
  SplitResponse,
  StatisticsResponse,
  UserGoldenProjectionResolveResponse,
  UserHostGraphTraversalResponse,
  UserPersonErasureResponse,
} from '../models/index';
import {
    ApproveResponseFromJSON,
    ApproveResponseToJSON,
    BootstrapResponseFromJSON,
    BootstrapResponseToJSON,
    ContainerGraphTraversalResponseFromJSON,
    ContainerGraphTraversalResponseToJSON,
    ContainerLayeredBackfillResponseFromJSON,
    ContainerLayeredBackfillResponseToJSON,
    CreateIncidentInvestigationLockRequestFromJSON,
    CreateIncidentInvestigationLockRequestToJSON,
    CreateInvestigationLockRequestFromJSON,
    CreateInvestigationLockRequestToJSON,
    DeduplicationRequestFromJSON,
    DeduplicationRequestToJSON,
    DeduplicationResponseFromJSON,
    DeduplicationResponseToJSON,
    DeprecateRequestFromJSON,
    DeprecateRequestToJSON,
    FullDeduplicationRequestFromJSON,
    FullDeduplicationRequestToJSON,
    GoldenRecordResponseFromJSON,
    GoldenRecordResponseToJSON,
    GoldenRecordsResponseFromJSON,
    GoldenRecordsResponseToJSON,
    IdentityClusterResponseFromJSON,
    IdentityClusterResponseToJSON,
    InvestigationLockReleaseByIncidentResponseFromJSON,
    InvestigationLockReleaseByIncidentResponseToJSON,
    InvestigationLockResponseFromJSON,
    InvestigationLockResponseToJSON,
    MdmBootstrapFieldMismatchRemediateRequestFromJSON,
    MdmBootstrapFieldMismatchRemediateRequestToJSON,
    MdmBootstrapFieldMismatchRemediateResultDtoFromJSON,
    MdmBootstrapFieldMismatchRemediateResultDtoToJSON,
    MdmBootstrapFieldMismatchReportDtoFromJSON,
    MdmBootstrapFieldMismatchReportDtoToJSON,
    MdmDuplicateCandidateFiltersResponseFromJSON,
    MdmDuplicateCandidateFiltersResponseToJSON,
    MdmDuplicateCandidatesListResponseFromJSON,
    MdmDuplicateCandidatesListResponseToJSON,
    MdmMatchPreviewRequestFromJSON,
    MdmMatchPreviewRequestToJSON,
    MdmMatchPreviewResponseFromJSON,
    MdmMatchPreviewResponseToJSON,
    MdmMatchingPolicyDetailDtoFromJSON,
    MdmMatchingPolicyDetailDtoToJSON,
    MdmMatchingPolicyImpactPreviewDtoFromJSON,
    MdmMatchingPolicyImpactPreviewDtoToJSON,
    MdmMatchingPolicyListResponseFromJSON,
    MdmMatchingPolicyListResponseToJSON,
    MdmPolicyRematchJobRequestFromJSON,
    MdmPolicyRematchJobRequestToJSON,
    MdmPolicyRematchJobResultDtoFromJSON,
    MdmPolicyRematchJobResultDtoToJSON,
    MdmPreviewEntitySearchResponseFromJSON,
    MdmPreviewEntitySearchResponseToJSON,
    MergeEventsResponseFromJSON,
    MergeEventsResponseToJSON,
    MergeGoldenRecordsRequestFromJSON,
    MergeGoldenRecordsRequestToJSON,
    OperationalGoldenLinkBackfillRequestFromJSON,
    OperationalGoldenLinkBackfillRequestToJSON,
    OperationalGoldenLinkBackfillResponseFromJSON,
    OperationalGoldenLinkBackfillResponseToJSON,
    RejectRequestFromJSON,
    RejectRequestToJSON,
    RejectResponseFromJSON,
    RejectResponseToJSON,
    SaveMdmMatchingPolicyRequestFromJSON,
    SaveMdmMatchingPolicyRequestToJSON,
    SplitRequestFromJSON,
    SplitRequestToJSON,
    SplitResponseFromJSON,
    SplitResponseToJSON,
    StatisticsResponseFromJSON,
    StatisticsResponseToJSON,
    UserGoldenProjectionResolveResponseFromJSON,
    UserGoldenProjectionResolveResponseToJSON,
    UserHostGraphTraversalResponseFromJSON,
    UserHostGraphTraversalResponseToJSON,
    UserPersonErasureResponseFromJSON,
    UserPersonErasureResponseToJSON,
} from '../models/index';

export interface ActivateMatchingPolicyRequest {
    sessionId: string;
    configurationId: string;
}

export interface ApproveMergeRequest {
    id: string;
    sessionId: string;
}

export interface BackfillLayeredContainersRequest {
    sessionId: string;
}

export interface BootstrapConfigurationRequest {
    sessionId: string;
}

export interface CreateIncidentInvestigationLockOperationRequest {
    sessionId: string;
    createIncidentInvestigationLockRequest: CreateIncidentInvestigationLockRequest;
}

export interface CreateInvestigationLockOperationRequest {
    sessionId: string;
    createInvestigationLockRequest: CreateInvestigationLockRequest;
}

export interface CreateMatchingPolicyDraftRequest {
    sessionId: string;
    assetClass: string;
}

export interface DeprecateGoldenRecordRequest {
    id: string;
    sessionId: string;
    deprecateRequest: DeprecateRequest;
}

export interface DiscardMatchingPolicyDraftRequest {
    sessionId: string;
    configurationId: string;
}

export interface DuplicateMatchingPolicyRequest {
    sessionId: string;
    configurationId: string;
}

export interface ErasePersonGoldenRequest {
    personId: string;
    sessionId: string;
    tenantId: string;
}

export interface GetCandidateFiltersRequest {
    sessionId: string;
    entityType: string;
}

export interface GetEffectiveMatchingPolicyRequest {
    sessionId: string;
    assetClass: string;
}

export interface GetGoldenRecordRequest {
    id: string;
    sessionId: string;
}

export interface GetGoldenRecordsRequest {
    sessionId: string;
    entityType: string;
    page?: number;
    size?: number;
}

export interface GetIdentityClusterRequest {
    id: string;
    sessionId: string;
}

export interface GetMatchingPolicyRequest {
    sessionId: string;
    configurationId: string;
}

export interface GetPendingCandidatesRequest {
    sessionId: string;
    entityType: string;
    page?: number;
    size?: number;
    decisiveTier?: number;
    guardVeto?: string;
    sourceSystem?: string;
}

export interface GetStatisticsRequest {
    sessionId: string;
    entityType: string;
}

export interface ListBootstrapFieldMismatchesRequest {
    sessionId: string;
}

export interface ListMatchingPoliciesRequest {
    sessionId: string;
    assetClass: string;
}

export interface ListMergeEventsRequest {
    id: string;
    sessionId: string;
}

export interface MatchPreviewRequest {
    sessionId: string;
    mdmMatchPreviewRequest: MdmMatchPreviewRequest;
}

export interface MatchingPolicyImpactPreviewRequest {
    sessionId: string;
    assetClass: string;
    draftConfigurationId?: string;
}

export interface MergeGoldenRecordsOperationRequest {
    sessionId: string;
    mergeGoldenRecordsRequest: MergeGoldenRecordsRequest;
}

export interface OperationalGoldenLinkBackfillOperationRequest {
    sessionId: string;
    operationalGoldenLinkBackfillRequest?: OperationalGoldenLinkBackfillRequest;
}

export interface RejectCandidateRequest {
    id: string;
    sessionId: string;
    rejectRequest: RejectRequest;
}

export interface ReleaseInvestigationLockRequest {
    lockId: string;
    sessionId: string;
    tenantId: string;
}

export interface ReleaseLocksByIncidentRequest {
    incidentId: string;
    sessionId: string;
    tenantId: string;
}

export interface RemediateBootstrapFieldMismatchesRequest {
    sessionId: string;
    mdmBootstrapFieldMismatchRemediateRequest?: MdmBootstrapFieldMismatchRemediateRequest;
}

export interface ResolveUserGoldenProjectionRequest {
    goldenRecordId: string;
    sessionId: string;
    tenantId: string;
}

export interface RunDeduplicationRequest {
    sessionId: string;
    deduplicationRequest: DeduplicationRequest;
}

export interface RunFullDeduplicationRequest {
    sessionId: string;
    fullDeduplicationRequest: FullDeduplicationRequest;
}

export interface RunMatchingPolicyRematchJobRequest {
    sessionId: string;
    mdmPolicyRematchJobRequest: MdmPolicyRematchJobRequest;
}

export interface SaveMatchingPolicyRequest {
    sessionId: string;
    saveMdmMatchingPolicyRequest: SaveMdmMatchingPolicyRequest;
}

export interface SearchPreviewEntitiesRequest {
    sessionId: string;
    entityType: string;
    q: string;
    limit?: number;
}

export interface SplitGoldenRecordRequest {
    id: string;
    sessionId: string;
    splitRequest: SplitRequest;
}

export interface TraverseContainerGraphFromHostRequest {
    sessionId: string;
    assetId: string;
    maxHops?: number;
    maxNodes?: number;
}

export interface TraverseContainerGraphFromImageRequest {
    sessionId: string;
    imageDigest: string;
    maxHops?: number;
    maxNodes?: number;
}

export interface TraverseUserHostGraphFromAccountRequest {
    sessionId: string;
    accountGoldenId: string;
    windowDays?: number;
    maxNodes?: number;
}

export interface TraverseUserHostGraphFromPersonRequest {
    sessionId: string;
    personGoldenId: string;
    windowDays?: number;
    maxNodes?: number;
}

/**
 * MDMApi - interface
 * 
 * @export
 * @interface MDMApiInterface
 */
export interface MDMApiInterface {
    /**
     * 
     * @summary Activate policy version (prospective-only; no bulk rematch)
     * @param {string} sessionId 
     * @param {string} configurationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MDMApiInterface
     */
    activateMatchingPolicyRaw(requestParameters: ActivateMatchingPolicyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MdmMatchingPolicyDetailDto>>;

    /**
     * Activate policy version (prospective-only; no bulk rematch)
     */
    activateMatchingPolicy(requestParameters: ActivateMatchingPolicyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MdmMatchingPolicyDetailDto>;

    /**
     * 
     * @summary Approve merge for duplicate candidate
     * @param {string} id 
     * @param {string} sessionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MDMApiInterface
     */
    approveMergeRaw(requestParameters: ApproveMergeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ApproveResponse>>;

    /**
     * Approve merge for duplicate candidate
     */
    approveMerge(requestParameters: ApproveMergeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ApproveResponse>;

    /**
     * 
     * @summary Backfill layered container tables from legacy containers
     * @param {string} sessionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MDMApiInterface
     */
    backfillLayeredContainersRaw(requestParameters: BackfillLayeredContainersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ContainerLayeredBackfillResponse>>;

    /**
     * Backfill layered container tables from legacy containers
     */
    backfillLayeredContainers(requestParameters: BackfillLayeredContainersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ContainerLayeredBackfillResponse>;

    /**
     * 
     * @summary Bootstrap default MDM configuration for tenant
     * @param {string} sessionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MDMApiInterface
     */
    bootstrapConfigurationRaw(requestParameters: BootstrapConfigurationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BootstrapResponse>>;

    /**
     * Bootstrap default MDM configuration for tenant
     */
    bootstrapConfiguration(requestParameters: BootstrapConfigurationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BootstrapResponse>;

    /**
     * 
     * @summary Create AUTO investigation lock when incident links Person golden
     * @param {string} sessionId 
     * @param {CreateIncidentInvestigationLockRequest} createIncidentInvestigationLockRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MDMApiInterface
     */
    createIncidentInvestigationLockRaw(requestParameters: CreateIncidentInvestigationLockOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InvestigationLockResponse>>;

    /**
     * Create AUTO investigation lock when incident links Person golden
     */
    createIncidentInvestigationLock(requestParameters: CreateIncidentInvestigationLockOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InvestigationLockResponse>;

    /**
     * 
     * @summary Create manual investigation lock on Person or Account golden
     * @param {string} sessionId 
     * @param {CreateInvestigationLockRequest} createInvestigationLockRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MDMApiInterface
     */
    createInvestigationLockRaw(requestParameters: CreateInvestigationLockOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InvestigationLockResponse>>;

    /**
     * Create manual investigation lock on Person or Account golden
     */
    createInvestigationLock(requestParameters: CreateInvestigationLockOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InvestigationLockResponse>;

    /**
     * 
     * @summary Create draft policy from active (or import legacy rules)
     * @param {string} sessionId 
     * @param {string} assetClass 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MDMApiInterface
     */
    createMatchingPolicyDraftRaw(requestParameters: CreateMatchingPolicyDraftRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MdmMatchingPolicyDetailDto>>;

    /**
     * Create draft policy from active (or import legacy rules)
     */
    createMatchingPolicyDraft(requestParameters: CreateMatchingPolicyDraftRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MdmMatchingPolicyDetailDto>;

    /**
     * 
     * @summary Deprecate a golden record
     * @param {string} id 
     * @param {string} sessionId 
     * @param {DeprecateRequest} deprecateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MDMApiInterface
     */
    deprecateGoldenRecordRaw(requestParameters: DeprecateGoldenRecordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GoldenRecordResponse>>;

    /**
     * Deprecate a golden record
     */
    deprecateGoldenRecord(requestParameters: DeprecateGoldenRecordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GoldenRecordResponse>;

    /**
     * 
     * @summary Discard draft MDM matching policy (soft-delete configuration)
     * @param {string} sessionId 
     * @param {string} configurationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MDMApiInterface
     */
    discardMatchingPolicyDraftRaw(requestParameters: DiscardMatchingPolicyDraftRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Discard draft MDM matching policy (soft-delete configuration)
     */
    discardMatchingPolicyDraft(requestParameters: DiscardMatchingPolicyDraftRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Duplicate a policy version as a new draft (REQ-UI-27)
     * @param {string} sessionId 
     * @param {string} configurationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MDMApiInterface
     */
    duplicateMatchingPolicyRaw(requestParameters: DuplicateMatchingPolicyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MdmMatchingPolicyDetailDto>>;

    /**
     * Duplicate a policy version as a new draft (REQ-UI-27)
     */
    duplicateMatchingPolicy(requestParameters: DuplicateMatchingPolicyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MdmMatchingPolicyDetailDto>;

    /**
     * 
     * @summary Erase user identity observations for a Person golden
     * @param {string} personId 
     * @param {string} sessionId 
     * @param {string} tenantId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MDMApiInterface
     */
    erasePersonGoldenRaw(requestParameters: ErasePersonGoldenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserPersonErasureResponse>>;

    /**
     * Erase user identity observations for a Person golden
     */
    erasePersonGolden(requestParameters: ErasePersonGoldenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserPersonErasureResponse>;

    /**
     * 
     * @summary Distinct filter values for duplicate review queue
     * @param {string} sessionId 
     * @param {string} entityType 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MDMApiInterface
     */
    getCandidateFiltersRaw(requestParameters: GetCandidateFiltersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MdmDuplicateCandidateFiltersResponse>>;

    /**
     * Distinct filter values for duplicate review queue
     */
    getCandidateFilters(requestParameters: GetCandidateFiltersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MdmDuplicateCandidateFiltersResponse>;

    /**
     * 
     * @summary Get the MDM matching policy currently in effect for an asset class
     * @param {string} sessionId 
     * @param {string} assetClass 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MDMApiInterface
     */
    getEffectiveMatchingPolicyRaw(requestParameters: GetEffectiveMatchingPolicyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MdmMatchingPolicyDetailDto>>;

    /**
     * Get the MDM matching policy currently in effect for an asset class
     */
    getEffectiveMatchingPolicy(requestParameters: GetEffectiveMatchingPolicyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MdmMatchingPolicyDetailDto>;

    /**
     * 
     * @summary Get golden record by ID
     * @param {string} id 
     * @param {string} sessionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MDMApiInterface
     */
    getGoldenRecordRaw(requestParameters: GetGoldenRecordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GoldenRecordResponse>>;

    /**
     * Get golden record by ID
     */
    getGoldenRecord(requestParameters: GetGoldenRecordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GoldenRecordResponse>;

    /**
     * 
     * @summary Get active golden records
     * @param {string} sessionId 
     * @param {string} entityType 
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MDMApiInterface
     */
    getGoldenRecordsRaw(requestParameters: GetGoldenRecordsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GoldenRecordsResponse>>;

    /**
     * Get active golden records
     */
    getGoldenRecords(requestParameters: GetGoldenRecordsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GoldenRecordsResponse>;

    /**
     * 
     * @summary Get identity cluster for a golden record (REQ-GOV-01)
     * @param {string} id 
     * @param {string} sessionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MDMApiInterface
     */
    getIdentityClusterRaw(requestParameters: GetIdentityClusterRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IdentityClusterResponse>>;

    /**
     * Get identity cluster for a golden record (REQ-GOV-01)
     */
    getIdentityCluster(requestParameters: GetIdentityClusterRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IdentityClusterResponse>;

    /**
     * 
     * @summary Get MDM matching policy version by configuration id
     * @param {string} sessionId 
     * @param {string} configurationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MDMApiInterface
     */
    getMatchingPolicyRaw(requestParameters: GetMatchingPolicyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MdmMatchingPolicyDetailDto>>;

    /**
     * Get MDM matching policy version by configuration id
     */
    getMatchingPolicy(requestParameters: GetMatchingPolicyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MdmMatchingPolicyDetailDto>;

    /**
     * 
     * @summary Get pending duplicate candidates
     * @param {string} sessionId Session id
     * @param {string} entityType ASSET, CONTAINER, or USER
     * @param {number} [page] Zero-based page index
     * @param {number} [size] Page size
     * @param {number} [decisiveTier] Filter by decisive match tier (1-5)
     * @param {string} [guardVeto] Filter by guard veto key
     * @param {string} [sourceSystem] Filter by source system on either side
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MDMApiInterface
     */
    getPendingCandidatesRaw(requestParameters: GetPendingCandidatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MdmDuplicateCandidatesListResponse>>;

    /**
     * Get pending duplicate candidates
     */
    getPendingCandidates(requestParameters: GetPendingCandidatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MdmDuplicateCandidatesListResponse>;

    /**
     * 
     * @summary Get MDM statistics
     * @param {string} sessionId 
     * @param {string} entityType 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MDMApiInterface
     */
    getStatisticsRaw(requestParameters: GetStatisticsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StatisticsResponse>>;

    /**
     * Get MDM statistics
     */
    getStatistics(requestParameters: GetStatisticsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StatisticsResponse>;

    /**
     * 
     * @summary List persisted legacy MDM rule field_name keys for tenant (16.BACK.1)
     * @param {string} sessionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MDMApiInterface
     */
    listBootstrapFieldMismatchesRaw(requestParameters: ListBootstrapFieldMismatchesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MdmBootstrapFieldMismatchReportDto>>;

    /**
     * List persisted legacy MDM rule field_name keys for tenant (16.BACK.1)
     */
    listBootstrapFieldMismatches(requestParameters: ListBootstrapFieldMismatchesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MdmBootstrapFieldMismatchReportDto>;

    /**
     * 
     * @summary List versioned MDM matching policies for an asset class
     * @param {string} sessionId 
     * @param {string} assetClass 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MDMApiInterface
     */
    listMatchingPoliciesRaw(requestParameters: ListMatchingPoliciesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MdmMatchingPolicyListResponse>>;

    /**
     * List versioned MDM matching policies for an asset class
     */
    listMatchingPolicies(requestParameters: ListMatchingPoliciesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MdmMatchingPolicyListResponse>;

    /**
     * 
     * @summary List merge/split audit events for a golden record (REQ-GOV-01)
     * @param {string} id 
     * @param {string} sessionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MDMApiInterface
     */
    listMergeEventsRaw(requestParameters: ListMergeEventsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MergeEventsResponse>>;

    /**
     * List merge/split audit events for a golden record (REQ-GOV-01)
     */
    listMergeEvents(requestParameters: ListMergeEventsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MergeEventsResponse>;

    /**
     * 
     * @summary Dry-run match preview for two entities (REQ-UI-11, read-only)
     * @param {string} sessionId 
     * @param {MdmMatchPreviewRequest} mdmMatchPreviewRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MDMApiInterface
     */
    matchPreviewRaw(requestParameters: MatchPreviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MdmMatchPreviewResponse>>;

    /**
     * Dry-run match preview for two entities (REQ-UI-11, read-only)
     */
    matchPreview(requestParameters: MatchPreviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MdmMatchPreviewResponse>;

    /**
     * 
     * @summary Dry-run impact summary before activate (REQ-GOV-07)
     * @param {string} sessionId 
     * @param {string} assetClass 
     * @param {string} [draftConfigurationId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MDMApiInterface
     */
    matchingPolicyImpactPreviewRaw(requestParameters: MatchingPolicyImpactPreviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MdmMatchingPolicyImpactPreviewDto>>;

    /**
     * Dry-run impact summary before activate (REQ-GOV-07)
     */
    matchingPolicyImpactPreview(requestParameters: MatchingPolicyImpactPreviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MdmMatchingPolicyImpactPreviewDto>;

    /**
     * 
     * @summary Merge multiple golden records into one
     * @param {string} sessionId 
     * @param {MergeGoldenRecordsRequest} mergeGoldenRecordsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MDMApiInterface
     */
    mergeGoldenRecordsRaw(requestParameters: MergeGoldenRecordsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GoldenRecordResponse>>;

    /**
     * Merge multiple golden records into one
     */
    mergeGoldenRecords(requestParameters: MergeGoldenRecordsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GoldenRecordResponse>;

    /**
     * 
     * @summary Backfill operational golden_record_id from active MDM goldens for current tenant
     * @param {string} sessionId 
     * @param {OperationalGoldenLinkBackfillRequest} [operationalGoldenLinkBackfillRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MDMApiInterface
     */
    operationalGoldenLinkBackfillRaw(requestParameters: OperationalGoldenLinkBackfillOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationalGoldenLinkBackfillResponse>>;

    /**
     * Backfill operational golden_record_id from active MDM goldens for current tenant
     */
    operationalGoldenLinkBackfill(requestParameters: OperationalGoldenLinkBackfillOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationalGoldenLinkBackfillResponse>;

    /**
     * 
     * @summary Reject duplicate candidate
     * @param {string} id 
     * @param {string} sessionId 
     * @param {RejectRequest} rejectRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MDMApiInterface
     */
    rejectCandidateRaw(requestParameters: RejectCandidateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RejectResponse>>;

    /**
     * Reject duplicate candidate
     */
    rejectCandidate(requestParameters: RejectCandidateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RejectResponse>;

    /**
     * 
     * @summary Release investigation lock and re-evaluate LOCKED_PENDING candidates
     * @param {string} lockId 
     * @param {string} sessionId 
     * @param {string} tenantId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MDMApiInterface
     */
    releaseInvestigationLockRaw(requestParameters: ReleaseInvestigationLockRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InvestigationLockResponse>>;

    /**
     * Release investigation lock and re-evaluate LOCKED_PENDING candidates
     */
    releaseInvestigationLock(requestParameters: ReleaseInvestigationLockRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InvestigationLockResponse>;

    /**
     * 
     * @summary Release all investigation locks for a closed incident
     * @param {string} incidentId 
     * @param {string} sessionId 
     * @param {string} tenantId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MDMApiInterface
     */
    releaseLocksByIncidentRaw(requestParameters: ReleaseLocksByIncidentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InvestigationLockReleaseByIncidentResponse>>;

    /**
     * Release all investigation locks for a closed incident
     */
    releaseLocksByIncident(requestParameters: ReleaseLocksByIncidentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InvestigationLockReleaseByIncidentResponse>;

    /**
     * 
     * @summary Rewrite legacy field_name keys to canonical plural keys in tenant MDM rules
     * @param {string} sessionId 
     * @param {MdmBootstrapFieldMismatchRemediateRequest} [mdmBootstrapFieldMismatchRemediateRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MDMApiInterface
     */
    remediateBootstrapFieldMismatchesRaw(requestParameters: RemediateBootstrapFieldMismatchesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MdmBootstrapFieldMismatchRemediateResultDto>>;

    /**
     * Rewrite legacy field_name keys to canonical plural keys in tenant MDM rules
     */
    remediateBootstrapFieldMismatches(requestParameters: RemediateBootstrapFieldMismatchesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MdmBootstrapFieldMismatchRemediateResultDto>;

    /**
     * 
     * @summary Resolve USER golden record to Person/Account projection row
     * @param {string} goldenRecordId 
     * @param {string} sessionId 
     * @param {string} tenantId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MDMApiInterface
     */
    resolveUserGoldenProjectionRaw(requestParameters: ResolveUserGoldenProjectionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserGoldenProjectionResolveResponse>>;

    /**
     * Resolve USER golden record to Person/Account projection row
     */
    resolveUserGoldenProjection(requestParameters: ResolveUserGoldenProjectionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserGoldenProjectionResolveResponse>;

    /**
     * 
     * @summary Run deduplication for integration instance
     * @param {string} sessionId 
     * @param {DeduplicationRequest} deduplicationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MDMApiInterface
     */
    runDeduplicationRaw(requestParameters: RunDeduplicationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeduplicationResponse>>;

    /**
     * Run deduplication for integration instance
     */
    runDeduplication(requestParameters: RunDeduplicationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeduplicationResponse>;

    /**
     * 
     * @summary Run full deduplication for all entities
     * @param {string} sessionId 
     * @param {FullDeduplicationRequest} fullDeduplicationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MDMApiInterface
     */
    runFullDeduplicationRaw(requestParameters: RunFullDeduplicationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeduplicationResponse>>;

    /**
     * Run full deduplication for all entities
     */
    runFullDeduplication(requestParameters: RunFullDeduplicationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeduplicationResponse>;

    /**
     * 
     * @summary Run or dry-run controlled re-match after policy change (REQ-GOV-07)
     * @param {string} sessionId 
     * @param {MdmPolicyRematchJobRequest} mdmPolicyRematchJobRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MDMApiInterface
     */
    runMatchingPolicyRematchJobRaw(requestParameters: RunMatchingPolicyRematchJobRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MdmPolicyRematchJobResultDto>>;

    /**
     * Run or dry-run controlled re-match after policy change (REQ-GOV-07)
     */
    runMatchingPolicyRematchJob(requestParameters: RunMatchingPolicyRematchJobRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MdmPolicyRematchJobResultDto>;

    /**
     * 
     * @summary Save draft MDM matching policy (prospective-only)
     * @param {string} sessionId 
     * @param {SaveMdmMatchingPolicyRequest} saveMdmMatchingPolicyRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MDMApiInterface
     */
    saveMatchingPolicyRaw(requestParameters: SaveMatchingPolicyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MdmMatchingPolicyDetailDto>>;

    /**
     * Save draft MDM matching policy (prospective-only)
     */
    saveMatchingPolicy(requestParameters: SaveMatchingPolicyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MdmMatchingPolicyDetailDto>;

    /**
     * 
     * @summary Search MDM source rows for match preview picker
     * @param {string} sessionId 
     * @param {string} entityType 
     * @param {string} q 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MDMApiInterface
     */
    searchPreviewEntitiesRaw(requestParameters: SearchPreviewEntitiesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MdmPreviewEntitySearchResponse>>;

    /**
     * Search MDM source rows for match preview picker
     */
    searchPreviewEntities(requestParameters: SearchPreviewEntitiesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MdmPreviewEntitySearchResponse>;

    /**
     * 
     * @summary Split a golden record into multiple records
     * @param {string} id 
     * @param {string} sessionId 
     * @param {SplitRequest} splitRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MDMApiInterface
     */
    splitGoldenRecordRaw(requestParameters: SplitGoldenRecordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SplitResponse>>;

    /**
     * Split a golden record into multiple records
     */
    splitGoldenRecord(requestParameters: SplitGoldenRecordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SplitResponse>;

    /**
     * 
     * @summary Traverse container graph from host asset
     * @param {string} sessionId 
     * @param {string} assetId 
     * @param {number} [maxHops] 
     * @param {number} [maxNodes] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MDMApiInterface
     */
    traverseContainerGraphFromHostRaw(requestParameters: TraverseContainerGraphFromHostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ContainerGraphTraversalResponse>>;

    /**
     * Traverse container graph from host asset
     */
    traverseContainerGraphFromHost(requestParameters: TraverseContainerGraphFromHostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ContainerGraphTraversalResponse>;

    /**
     * 
     * @summary Traverse container graph from image digest
     * @param {string} sessionId 
     * @param {string} imageDigest 
     * @param {number} [maxHops] 
     * @param {number} [maxNodes] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MDMApiInterface
     */
    traverseContainerGraphFromImageRaw(requestParameters: TraverseContainerGraphFromImageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ContainerGraphTraversalResponse>>;

    /**
     * Traverse container graph from image digest
     */
    traverseContainerGraphFromImage(requestParameters: TraverseContainerGraphFromImageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ContainerGraphTraversalResponse>;

    /**
     * 
     * @summary Traverse user–host graph from Account golden
     * @param {string} sessionId 
     * @param {string} accountGoldenId 
     * @param {number} [windowDays] 
     * @param {number} [maxNodes] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MDMApiInterface
     */
    traverseUserHostGraphFromAccountRaw(requestParameters: TraverseUserHostGraphFromAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserHostGraphTraversalResponse>>;

    /**
     * Traverse user–host graph from Account golden
     */
    traverseUserHostGraphFromAccount(requestParameters: TraverseUserHostGraphFromAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserHostGraphTraversalResponse>;

    /**
     * 
     * @summary Traverse user–host graph from Person golden
     * @param {string} sessionId 
     * @param {string} personGoldenId 
     * @param {number} [windowDays] 
     * @param {number} [maxNodes] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MDMApiInterface
     */
    traverseUserHostGraphFromPersonRaw(requestParameters: TraverseUserHostGraphFromPersonRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserHostGraphTraversalResponse>>;

    /**
     * Traverse user–host graph from Person golden
     */
    traverseUserHostGraphFromPerson(requestParameters: TraverseUserHostGraphFromPersonRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserHostGraphTraversalResponse>;

}

/**
 * 
 */
export class MDMApi extends runtime.BaseAPI implements MDMApiInterface {

    /**
     * Activate policy version (prospective-only; no bulk rematch)
     */
    async activateMatchingPolicyRaw(requestParameters: ActivateMatchingPolicyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MdmMatchingPolicyDetailDto>> {
        if (requestParameters['sessionId'] == null) {
            throw new runtime.RequiredError(
                'sessionId',
                'Required parameter "sessionId" was null or undefined when calling activateMatchingPolicy().'
            );
        }

        if (requestParameters['configurationId'] == null) {
            throw new runtime.RequiredError(
                'configurationId',
                'Required parameter "configurationId" was null or undefined when calling activateMatchingPolicy().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/mdm/policies/{configurationId}/activate`;
        urlPath = urlPath.replace(`{${"configurationId"}}`, encodeURIComponent(String(requestParameters['configurationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MdmMatchingPolicyDetailDtoFromJSON(jsonValue));
    }

    /**
     * Activate policy version (prospective-only; no bulk rematch)
     */
    async activateMatchingPolicy(requestParameters: ActivateMatchingPolicyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MdmMatchingPolicyDetailDto> {
        const response = await this.activateMatchingPolicyRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Approve merge for duplicate candidate
     */
    async approveMergeRaw(requestParameters: ApproveMergeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ApproveResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling approveMerge().'
            );
        }

        if (requestParameters['sessionId'] == null) {
            throw new runtime.RequiredError(
                'sessionId',
                'Required parameter "sessionId" was null or undefined when calling approveMerge().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/mdm/candidates/{id}/approve`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApproveResponseFromJSON(jsonValue));
    }

    /**
     * Approve merge for duplicate candidate
     */
    async approveMerge(requestParameters: ApproveMergeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ApproveResponse> {
        const response = await this.approveMergeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Backfill layered container tables from legacy containers
     */
    async backfillLayeredContainersRaw(requestParameters: BackfillLayeredContainersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ContainerLayeredBackfillResponse>> {
        if (requestParameters['sessionId'] == null) {
            throw new runtime.RequiredError(
                'sessionId',
                'Required parameter "sessionId" was null or undefined when calling backfillLayeredContainers().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/mdm/containers/backfill-layered`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ContainerLayeredBackfillResponseFromJSON(jsonValue));
    }

    /**
     * Backfill layered container tables from legacy containers
     */
    async backfillLayeredContainers(requestParameters: BackfillLayeredContainersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ContainerLayeredBackfillResponse> {
        const response = await this.backfillLayeredContainersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Bootstrap default MDM configuration for tenant
     */
    async bootstrapConfigurationRaw(requestParameters: BootstrapConfigurationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BootstrapResponse>> {
        if (requestParameters['sessionId'] == null) {
            throw new runtime.RequiredError(
                'sessionId',
                'Required parameter "sessionId" was null or undefined when calling bootstrapConfiguration().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/mdm/bootstrap`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BootstrapResponseFromJSON(jsonValue));
    }

    /**
     * Bootstrap default MDM configuration for tenant
     */
    async bootstrapConfiguration(requestParameters: BootstrapConfigurationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BootstrapResponse> {
        const response = await this.bootstrapConfigurationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create AUTO investigation lock when incident links Person golden
     */
    async createIncidentInvestigationLockRaw(requestParameters: CreateIncidentInvestigationLockOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InvestigationLockResponse>> {
        if (requestParameters['sessionId'] == null) {
            throw new runtime.RequiredError(
                'sessionId',
                'Required parameter "sessionId" was null or undefined when calling createIncidentInvestigationLock().'
            );
        }

        if (requestParameters['createIncidentInvestigationLockRequest'] == null) {
            throw new runtime.RequiredError(
                'createIncidentInvestigationLockRequest',
                'Required parameter "createIncidentInvestigationLockRequest" was null or undefined when calling createIncidentInvestigationLock().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/mdm/users/investigation-locks/incident`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateIncidentInvestigationLockRequestToJSON(requestParameters['createIncidentInvestigationLockRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InvestigationLockResponseFromJSON(jsonValue));
    }

    /**
     * Create AUTO investigation lock when incident links Person golden
     */
    async createIncidentInvestigationLock(requestParameters: CreateIncidentInvestigationLockOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InvestigationLockResponse> {
        const response = await this.createIncidentInvestigationLockRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create manual investigation lock on Person or Account golden
     */
    async createInvestigationLockRaw(requestParameters: CreateInvestigationLockOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InvestigationLockResponse>> {
        if (requestParameters['sessionId'] == null) {
            throw new runtime.RequiredError(
                'sessionId',
                'Required parameter "sessionId" was null or undefined when calling createInvestigationLock().'
            );
        }

        if (requestParameters['createInvestigationLockRequest'] == null) {
            throw new runtime.RequiredError(
                'createInvestigationLockRequest',
                'Required parameter "createInvestigationLockRequest" was null or undefined when calling createInvestigationLock().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/mdm/users/investigation-locks`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateInvestigationLockRequestToJSON(requestParameters['createInvestigationLockRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InvestigationLockResponseFromJSON(jsonValue));
    }

    /**
     * Create manual investigation lock on Person or Account golden
     */
    async createInvestigationLock(requestParameters: CreateInvestigationLockOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InvestigationLockResponse> {
        const response = await this.createInvestigationLockRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create draft policy from active (or import legacy rules)
     */
    async createMatchingPolicyDraftRaw(requestParameters: CreateMatchingPolicyDraftRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MdmMatchingPolicyDetailDto>> {
        if (requestParameters['sessionId'] == null) {
            throw new runtime.RequiredError(
                'sessionId',
                'Required parameter "sessionId" was null or undefined when calling createMatchingPolicyDraft().'
            );
        }

        if (requestParameters['assetClass'] == null) {
            throw new runtime.RequiredError(
                'assetClass',
                'Required parameter "assetClass" was null or undefined when calling createMatchingPolicyDraft().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        if (requestParameters['assetClass'] != null) {
            queryParameters['assetClass'] = requestParameters['assetClass'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/mdm/policies/draft`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MdmMatchingPolicyDetailDtoFromJSON(jsonValue));
    }

    /**
     * Create draft policy from active (or import legacy rules)
     */
    async createMatchingPolicyDraft(requestParameters: CreateMatchingPolicyDraftRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MdmMatchingPolicyDetailDto> {
        const response = await this.createMatchingPolicyDraftRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Deprecate a golden record
     */
    async deprecateGoldenRecordRaw(requestParameters: DeprecateGoldenRecordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GoldenRecordResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deprecateGoldenRecord().'
            );
        }

        if (requestParameters['sessionId'] == null) {
            throw new runtime.RequiredError(
                'sessionId',
                'Required parameter "sessionId" was null or undefined when calling deprecateGoldenRecord().'
            );
        }

        if (requestParameters['deprecateRequest'] == null) {
            throw new runtime.RequiredError(
                'deprecateRequest',
                'Required parameter "deprecateRequest" was null or undefined when calling deprecateGoldenRecord().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/mdm/golden-records/{id}/deprecate`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DeprecateRequestToJSON(requestParameters['deprecateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GoldenRecordResponseFromJSON(jsonValue));
    }

    /**
     * Deprecate a golden record
     */
    async deprecateGoldenRecord(requestParameters: DeprecateGoldenRecordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GoldenRecordResponse> {
        const response = await this.deprecateGoldenRecordRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Discard draft MDM matching policy (soft-delete configuration)
     */
    async discardMatchingPolicyDraftRaw(requestParameters: DiscardMatchingPolicyDraftRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['sessionId'] == null) {
            throw new runtime.RequiredError(
                'sessionId',
                'Required parameter "sessionId" was null or undefined when calling discardMatchingPolicyDraft().'
            );
        }

        if (requestParameters['configurationId'] == null) {
            throw new runtime.RequiredError(
                'configurationId',
                'Required parameter "configurationId" was null or undefined when calling discardMatchingPolicyDraft().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/mdm/policies/{configurationId}`;
        urlPath = urlPath.replace(`{${"configurationId"}}`, encodeURIComponent(String(requestParameters['configurationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Discard draft MDM matching policy (soft-delete configuration)
     */
    async discardMatchingPolicyDraft(requestParameters: DiscardMatchingPolicyDraftRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.discardMatchingPolicyDraftRaw(requestParameters, initOverrides);
    }

    /**
     * Duplicate a policy version as a new draft (REQ-UI-27)
     */
    async duplicateMatchingPolicyRaw(requestParameters: DuplicateMatchingPolicyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MdmMatchingPolicyDetailDto>> {
        if (requestParameters['sessionId'] == null) {
            throw new runtime.RequiredError(
                'sessionId',
                'Required parameter "sessionId" was null or undefined when calling duplicateMatchingPolicy().'
            );
        }

        if (requestParameters['configurationId'] == null) {
            throw new runtime.RequiredError(
                'configurationId',
                'Required parameter "configurationId" was null or undefined when calling duplicateMatchingPolicy().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/mdm/policies/{configurationId}/duplicate`;
        urlPath = urlPath.replace(`{${"configurationId"}}`, encodeURIComponent(String(requestParameters['configurationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MdmMatchingPolicyDetailDtoFromJSON(jsonValue));
    }

    /**
     * Duplicate a policy version as a new draft (REQ-UI-27)
     */
    async duplicateMatchingPolicy(requestParameters: DuplicateMatchingPolicyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MdmMatchingPolicyDetailDto> {
        const response = await this.duplicateMatchingPolicyRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Erase user identity observations for a Person golden
     */
    async erasePersonGoldenRaw(requestParameters: ErasePersonGoldenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserPersonErasureResponse>> {
        if (requestParameters['personId'] == null) {
            throw new runtime.RequiredError(
                'personId',
                'Required parameter "personId" was null or undefined when calling erasePersonGolden().'
            );
        }

        if (requestParameters['sessionId'] == null) {
            throw new runtime.RequiredError(
                'sessionId',
                'Required parameter "sessionId" was null or undefined when calling erasePersonGolden().'
            );
        }

        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling erasePersonGolden().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        if (requestParameters['tenantId'] != null) {
            queryParameters['tenantId'] = requestParameters['tenantId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/mdm/users/{personId}/erase`;
        urlPath = urlPath.replace(`{${"personId"}}`, encodeURIComponent(String(requestParameters['personId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserPersonErasureResponseFromJSON(jsonValue));
    }

    /**
     * Erase user identity observations for a Person golden
     */
    async erasePersonGolden(requestParameters: ErasePersonGoldenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserPersonErasureResponse> {
        const response = await this.erasePersonGoldenRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Distinct filter values for duplicate review queue
     */
    async getCandidateFiltersRaw(requestParameters: GetCandidateFiltersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MdmDuplicateCandidateFiltersResponse>> {
        if (requestParameters['sessionId'] == null) {
            throw new runtime.RequiredError(
                'sessionId',
                'Required parameter "sessionId" was null or undefined when calling getCandidateFilters().'
            );
        }

        if (requestParameters['entityType'] == null) {
            throw new runtime.RequiredError(
                'entityType',
                'Required parameter "entityType" was null or undefined when calling getCandidateFilters().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        if (requestParameters['entityType'] != null) {
            queryParameters['entityType'] = requestParameters['entityType'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/mdm/candidates/filters`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MdmDuplicateCandidateFiltersResponseFromJSON(jsonValue));
    }

    /**
     * Distinct filter values for duplicate review queue
     */
    async getCandidateFilters(requestParameters: GetCandidateFiltersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MdmDuplicateCandidateFiltersResponse> {
        const response = await this.getCandidateFiltersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get the MDM matching policy currently in effect for an asset class
     */
    async getEffectiveMatchingPolicyRaw(requestParameters: GetEffectiveMatchingPolicyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MdmMatchingPolicyDetailDto>> {
        if (requestParameters['sessionId'] == null) {
            throw new runtime.RequiredError(
                'sessionId',
                'Required parameter "sessionId" was null or undefined when calling getEffectiveMatchingPolicy().'
            );
        }

        if (requestParameters['assetClass'] == null) {
            throw new runtime.RequiredError(
                'assetClass',
                'Required parameter "assetClass" was null or undefined when calling getEffectiveMatchingPolicy().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        if (requestParameters['assetClass'] != null) {
            queryParameters['assetClass'] = requestParameters['assetClass'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/mdm/policies/effective`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MdmMatchingPolicyDetailDtoFromJSON(jsonValue));
    }

    /**
     * Get the MDM matching policy currently in effect for an asset class
     */
    async getEffectiveMatchingPolicy(requestParameters: GetEffectiveMatchingPolicyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MdmMatchingPolicyDetailDto> {
        const response = await this.getEffectiveMatchingPolicyRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get golden record by ID
     */
    async getGoldenRecordRaw(requestParameters: GetGoldenRecordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GoldenRecordResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getGoldenRecord().'
            );
        }

        if (requestParameters['sessionId'] == null) {
            throw new runtime.RequiredError(
                'sessionId',
                'Required parameter "sessionId" was null or undefined when calling getGoldenRecord().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/mdm/golden-records/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GoldenRecordResponseFromJSON(jsonValue));
    }

    /**
     * Get golden record by ID
     */
    async getGoldenRecord(requestParameters: GetGoldenRecordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GoldenRecordResponse> {
        const response = await this.getGoldenRecordRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get active golden records
     */
    async getGoldenRecordsRaw(requestParameters: GetGoldenRecordsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GoldenRecordsResponse>> {
        if (requestParameters['sessionId'] == null) {
            throw new runtime.RequiredError(
                'sessionId',
                'Required parameter "sessionId" was null or undefined when calling getGoldenRecords().'
            );
        }

        if (requestParameters['entityType'] == null) {
            throw new runtime.RequiredError(
                'entityType',
                'Required parameter "entityType" was null or undefined when calling getGoldenRecords().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        if (requestParameters['entityType'] != null) {
            queryParameters['entityType'] = requestParameters['entityType'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/mdm/golden-records`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GoldenRecordsResponseFromJSON(jsonValue));
    }

    /**
     * Get active golden records
     */
    async getGoldenRecords(requestParameters: GetGoldenRecordsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GoldenRecordsResponse> {
        const response = await this.getGoldenRecordsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get identity cluster for a golden record (REQ-GOV-01)
     */
    async getIdentityClusterRaw(requestParameters: GetIdentityClusterRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IdentityClusterResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getIdentityCluster().'
            );
        }

        if (requestParameters['sessionId'] == null) {
            throw new runtime.RequiredError(
                'sessionId',
                'Required parameter "sessionId" was null or undefined when calling getIdentityCluster().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/mdm/golden-records/{id}/identity-cluster`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IdentityClusterResponseFromJSON(jsonValue));
    }

    /**
     * Get identity cluster for a golden record (REQ-GOV-01)
     */
    async getIdentityCluster(requestParameters: GetIdentityClusterRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IdentityClusterResponse> {
        const response = await this.getIdentityClusterRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get MDM matching policy version by configuration id
     */
    async getMatchingPolicyRaw(requestParameters: GetMatchingPolicyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MdmMatchingPolicyDetailDto>> {
        if (requestParameters['sessionId'] == null) {
            throw new runtime.RequiredError(
                'sessionId',
                'Required parameter "sessionId" was null or undefined when calling getMatchingPolicy().'
            );
        }

        if (requestParameters['configurationId'] == null) {
            throw new runtime.RequiredError(
                'configurationId',
                'Required parameter "configurationId" was null or undefined when calling getMatchingPolicy().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/mdm/policies/{configurationId}`;
        urlPath = urlPath.replace(`{${"configurationId"}}`, encodeURIComponent(String(requestParameters['configurationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MdmMatchingPolicyDetailDtoFromJSON(jsonValue));
    }

    /**
     * Get MDM matching policy version by configuration id
     */
    async getMatchingPolicy(requestParameters: GetMatchingPolicyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MdmMatchingPolicyDetailDto> {
        const response = await this.getMatchingPolicyRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get pending duplicate candidates
     */
    async getPendingCandidatesRaw(requestParameters: GetPendingCandidatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MdmDuplicateCandidatesListResponse>> {
        if (requestParameters['sessionId'] == null) {
            throw new runtime.RequiredError(
                'sessionId',
                'Required parameter "sessionId" was null or undefined when calling getPendingCandidates().'
            );
        }

        if (requestParameters['entityType'] == null) {
            throw new runtime.RequiredError(
                'entityType',
                'Required parameter "entityType" was null or undefined when calling getPendingCandidates().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        if (requestParameters['entityType'] != null) {
            queryParameters['entityType'] = requestParameters['entityType'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        if (requestParameters['decisiveTier'] != null) {
            queryParameters['decisiveTier'] = requestParameters['decisiveTier'];
        }

        if (requestParameters['guardVeto'] != null) {
            queryParameters['guardVeto'] = requestParameters['guardVeto'];
        }

        if (requestParameters['sourceSystem'] != null) {
            queryParameters['sourceSystem'] = requestParameters['sourceSystem'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/mdm/candidates`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MdmDuplicateCandidatesListResponseFromJSON(jsonValue));
    }

    /**
     * Get pending duplicate candidates
     */
    async getPendingCandidates(requestParameters: GetPendingCandidatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MdmDuplicateCandidatesListResponse> {
        const response = await this.getPendingCandidatesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get MDM statistics
     */
    async getStatisticsRaw(requestParameters: GetStatisticsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StatisticsResponse>> {
        if (requestParameters['sessionId'] == null) {
            throw new runtime.RequiredError(
                'sessionId',
                'Required parameter "sessionId" was null or undefined when calling getStatistics().'
            );
        }

        if (requestParameters['entityType'] == null) {
            throw new runtime.RequiredError(
                'entityType',
                'Required parameter "entityType" was null or undefined when calling getStatistics().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        if (requestParameters['entityType'] != null) {
            queryParameters['entityType'] = requestParameters['entityType'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/mdm/statistics`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StatisticsResponseFromJSON(jsonValue));
    }

    /**
     * Get MDM statistics
     */
    async getStatistics(requestParameters: GetStatisticsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StatisticsResponse> {
        const response = await this.getStatisticsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List persisted legacy MDM rule field_name keys for tenant (16.BACK.1)
     */
    async listBootstrapFieldMismatchesRaw(requestParameters: ListBootstrapFieldMismatchesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MdmBootstrapFieldMismatchReportDto>> {
        if (requestParameters['sessionId'] == null) {
            throw new runtime.RequiredError(
                'sessionId',
                'Required parameter "sessionId" was null or undefined when calling listBootstrapFieldMismatches().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/mdm/bootstrap/field-mismatches`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MdmBootstrapFieldMismatchReportDtoFromJSON(jsonValue));
    }

    /**
     * List persisted legacy MDM rule field_name keys for tenant (16.BACK.1)
     */
    async listBootstrapFieldMismatches(requestParameters: ListBootstrapFieldMismatchesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MdmBootstrapFieldMismatchReportDto> {
        const response = await this.listBootstrapFieldMismatchesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List versioned MDM matching policies for an asset class
     */
    async listMatchingPoliciesRaw(requestParameters: ListMatchingPoliciesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MdmMatchingPolicyListResponse>> {
        if (requestParameters['sessionId'] == null) {
            throw new runtime.RequiredError(
                'sessionId',
                'Required parameter "sessionId" was null or undefined when calling listMatchingPolicies().'
            );
        }

        if (requestParameters['assetClass'] == null) {
            throw new runtime.RequiredError(
                'assetClass',
                'Required parameter "assetClass" was null or undefined when calling listMatchingPolicies().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        if (requestParameters['assetClass'] != null) {
            queryParameters['assetClass'] = requestParameters['assetClass'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/mdm/policies`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MdmMatchingPolicyListResponseFromJSON(jsonValue));
    }

    /**
     * List versioned MDM matching policies for an asset class
     */
    async listMatchingPolicies(requestParameters: ListMatchingPoliciesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MdmMatchingPolicyListResponse> {
        const response = await this.listMatchingPoliciesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List merge/split audit events for a golden record (REQ-GOV-01)
     */
    async listMergeEventsRaw(requestParameters: ListMergeEventsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MergeEventsResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling listMergeEvents().'
            );
        }

        if (requestParameters['sessionId'] == null) {
            throw new runtime.RequiredError(
                'sessionId',
                'Required parameter "sessionId" was null or undefined when calling listMergeEvents().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/mdm/golden-records/{id}/merge-events`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MergeEventsResponseFromJSON(jsonValue));
    }

    /**
     * List merge/split audit events for a golden record (REQ-GOV-01)
     */
    async listMergeEvents(requestParameters: ListMergeEventsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MergeEventsResponse> {
        const response = await this.listMergeEventsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Dry-run match preview for two entities (REQ-UI-11, read-only)
     */
    async matchPreviewRaw(requestParameters: MatchPreviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MdmMatchPreviewResponse>> {
        if (requestParameters['sessionId'] == null) {
            throw new runtime.RequiredError(
                'sessionId',
                'Required parameter "sessionId" was null or undefined when calling matchPreview().'
            );
        }

        if (requestParameters['mdmMatchPreviewRequest'] == null) {
            throw new runtime.RequiredError(
                'mdmMatchPreviewRequest',
                'Required parameter "mdmMatchPreviewRequest" was null or undefined when calling matchPreview().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/mdm/match/preview`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MdmMatchPreviewRequestToJSON(requestParameters['mdmMatchPreviewRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MdmMatchPreviewResponseFromJSON(jsonValue));
    }

    /**
     * Dry-run match preview for two entities (REQ-UI-11, read-only)
     */
    async matchPreview(requestParameters: MatchPreviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MdmMatchPreviewResponse> {
        const response = await this.matchPreviewRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Dry-run impact summary before activate (REQ-GOV-07)
     */
    async matchingPolicyImpactPreviewRaw(requestParameters: MatchingPolicyImpactPreviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MdmMatchingPolicyImpactPreviewDto>> {
        if (requestParameters['sessionId'] == null) {
            throw new runtime.RequiredError(
                'sessionId',
                'Required parameter "sessionId" was null or undefined when calling matchingPolicyImpactPreview().'
            );
        }

        if (requestParameters['assetClass'] == null) {
            throw new runtime.RequiredError(
                'assetClass',
                'Required parameter "assetClass" was null or undefined when calling matchingPolicyImpactPreview().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        if (requestParameters['assetClass'] != null) {
            queryParameters['assetClass'] = requestParameters['assetClass'];
        }

        if (requestParameters['draftConfigurationId'] != null) {
            queryParameters['draftConfigurationId'] = requestParameters['draftConfigurationId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/mdm/policies/impact-preview`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MdmMatchingPolicyImpactPreviewDtoFromJSON(jsonValue));
    }

    /**
     * Dry-run impact summary before activate (REQ-GOV-07)
     */
    async matchingPolicyImpactPreview(requestParameters: MatchingPolicyImpactPreviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MdmMatchingPolicyImpactPreviewDto> {
        const response = await this.matchingPolicyImpactPreviewRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Merge multiple golden records into one
     */
    async mergeGoldenRecordsRaw(requestParameters: MergeGoldenRecordsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GoldenRecordResponse>> {
        if (requestParameters['sessionId'] == null) {
            throw new runtime.RequiredError(
                'sessionId',
                'Required parameter "sessionId" was null or undefined when calling mergeGoldenRecords().'
            );
        }

        if (requestParameters['mergeGoldenRecordsRequest'] == null) {
            throw new runtime.RequiredError(
                'mergeGoldenRecordsRequest',
                'Required parameter "mergeGoldenRecordsRequest" was null or undefined when calling mergeGoldenRecords().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/mdm/golden-records/merge`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MergeGoldenRecordsRequestToJSON(requestParameters['mergeGoldenRecordsRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GoldenRecordResponseFromJSON(jsonValue));
    }

    /**
     * Merge multiple golden records into one
     */
    async mergeGoldenRecords(requestParameters: MergeGoldenRecordsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GoldenRecordResponse> {
        const response = await this.mergeGoldenRecordsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Backfill operational golden_record_id from active MDM goldens for current tenant
     */
    async operationalGoldenLinkBackfillRaw(requestParameters: OperationalGoldenLinkBackfillOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationalGoldenLinkBackfillResponse>> {
        if (requestParameters['sessionId'] == null) {
            throw new runtime.RequiredError(
                'sessionId',
                'Required parameter "sessionId" was null or undefined when calling operationalGoldenLinkBackfill().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/mdm/operational-golden-link-backfill`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: OperationalGoldenLinkBackfillRequestToJSON(requestParameters['operationalGoldenLinkBackfillRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationalGoldenLinkBackfillResponseFromJSON(jsonValue));
    }

    /**
     * Backfill operational golden_record_id from active MDM goldens for current tenant
     */
    async operationalGoldenLinkBackfill(requestParameters: OperationalGoldenLinkBackfillOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationalGoldenLinkBackfillResponse> {
        const response = await this.operationalGoldenLinkBackfillRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Reject duplicate candidate
     */
    async rejectCandidateRaw(requestParameters: RejectCandidateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RejectResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rejectCandidate().'
            );
        }

        if (requestParameters['sessionId'] == null) {
            throw new runtime.RequiredError(
                'sessionId',
                'Required parameter "sessionId" was null or undefined when calling rejectCandidate().'
            );
        }

        if (requestParameters['rejectRequest'] == null) {
            throw new runtime.RequiredError(
                'rejectRequest',
                'Required parameter "rejectRequest" was null or undefined when calling rejectCandidate().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/mdm/candidates/{id}/reject`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RejectRequestToJSON(requestParameters['rejectRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RejectResponseFromJSON(jsonValue));
    }

    /**
     * Reject duplicate candidate
     */
    async rejectCandidate(requestParameters: RejectCandidateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RejectResponse> {
        const response = await this.rejectCandidateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Release investigation lock and re-evaluate LOCKED_PENDING candidates
     */
    async releaseInvestigationLockRaw(requestParameters: ReleaseInvestigationLockRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InvestigationLockResponse>> {
        if (requestParameters['lockId'] == null) {
            throw new runtime.RequiredError(
                'lockId',
                'Required parameter "lockId" was null or undefined when calling releaseInvestigationLock().'
            );
        }

        if (requestParameters['sessionId'] == null) {
            throw new runtime.RequiredError(
                'sessionId',
                'Required parameter "sessionId" was null or undefined when calling releaseInvestigationLock().'
            );
        }

        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling releaseInvestigationLock().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        if (requestParameters['tenantId'] != null) {
            queryParameters['tenantId'] = requestParameters['tenantId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/mdm/investigation-locks/{lockId}/release`;
        urlPath = urlPath.replace(`{${"lockId"}}`, encodeURIComponent(String(requestParameters['lockId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InvestigationLockResponseFromJSON(jsonValue));
    }

    /**
     * Release investigation lock and re-evaluate LOCKED_PENDING candidates
     */
    async releaseInvestigationLock(requestParameters: ReleaseInvestigationLockRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InvestigationLockResponse> {
        const response = await this.releaseInvestigationLockRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Release all investigation locks for a closed incident
     */
    async releaseLocksByIncidentRaw(requestParameters: ReleaseLocksByIncidentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InvestigationLockReleaseByIncidentResponse>> {
        if (requestParameters['incidentId'] == null) {
            throw new runtime.RequiredError(
                'incidentId',
                'Required parameter "incidentId" was null or undefined when calling releaseLocksByIncident().'
            );
        }

        if (requestParameters['sessionId'] == null) {
            throw new runtime.RequiredError(
                'sessionId',
                'Required parameter "sessionId" was null or undefined when calling releaseLocksByIncident().'
            );
        }

        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling releaseLocksByIncident().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        if (requestParameters['tenantId'] != null) {
            queryParameters['tenantId'] = requestParameters['tenantId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/mdm/investigation-locks/release-by-incident/{incidentId}`;
        urlPath = urlPath.replace(`{${"incidentId"}}`, encodeURIComponent(String(requestParameters['incidentId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InvestigationLockReleaseByIncidentResponseFromJSON(jsonValue));
    }

    /**
     * Release all investigation locks for a closed incident
     */
    async releaseLocksByIncident(requestParameters: ReleaseLocksByIncidentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InvestigationLockReleaseByIncidentResponse> {
        const response = await this.releaseLocksByIncidentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Rewrite legacy field_name keys to canonical plural keys in tenant MDM rules
     */
    async remediateBootstrapFieldMismatchesRaw(requestParameters: RemediateBootstrapFieldMismatchesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MdmBootstrapFieldMismatchRemediateResultDto>> {
        if (requestParameters['sessionId'] == null) {
            throw new runtime.RequiredError(
                'sessionId',
                'Required parameter "sessionId" was null or undefined when calling remediateBootstrapFieldMismatches().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/mdm/bootstrap/remediate-field-mismatches`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MdmBootstrapFieldMismatchRemediateRequestToJSON(requestParameters['mdmBootstrapFieldMismatchRemediateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MdmBootstrapFieldMismatchRemediateResultDtoFromJSON(jsonValue));
    }

    /**
     * Rewrite legacy field_name keys to canonical plural keys in tenant MDM rules
     */
    async remediateBootstrapFieldMismatches(requestParameters: RemediateBootstrapFieldMismatchesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MdmBootstrapFieldMismatchRemediateResultDto> {
        const response = await this.remediateBootstrapFieldMismatchesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Resolve USER golden record to Person/Account projection row
     */
    async resolveUserGoldenProjectionRaw(requestParameters: ResolveUserGoldenProjectionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserGoldenProjectionResolveResponse>> {
        if (requestParameters['goldenRecordId'] == null) {
            throw new runtime.RequiredError(
                'goldenRecordId',
                'Required parameter "goldenRecordId" was null or undefined when calling resolveUserGoldenProjection().'
            );
        }

        if (requestParameters['sessionId'] == null) {
            throw new runtime.RequiredError(
                'sessionId',
                'Required parameter "sessionId" was null or undefined when calling resolveUserGoldenProjection().'
            );
        }

        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling resolveUserGoldenProjection().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        if (requestParameters['tenantId'] != null) {
            queryParameters['tenantId'] = requestParameters['tenantId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/mdm/golden-records/{goldenRecordId}/user-projection`;
        urlPath = urlPath.replace(`{${"goldenRecordId"}}`, encodeURIComponent(String(requestParameters['goldenRecordId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserGoldenProjectionResolveResponseFromJSON(jsonValue));
    }

    /**
     * Resolve USER golden record to Person/Account projection row
     */
    async resolveUserGoldenProjection(requestParameters: ResolveUserGoldenProjectionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserGoldenProjectionResolveResponse> {
        const response = await this.resolveUserGoldenProjectionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Run deduplication for integration instance
     */
    async runDeduplicationRaw(requestParameters: RunDeduplicationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeduplicationResponse>> {
        if (requestParameters['sessionId'] == null) {
            throw new runtime.RequiredError(
                'sessionId',
                'Required parameter "sessionId" was null or undefined when calling runDeduplication().'
            );
        }

        if (requestParameters['deduplicationRequest'] == null) {
            throw new runtime.RequiredError(
                'deduplicationRequest',
                'Required parameter "deduplicationRequest" was null or undefined when calling runDeduplication().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/mdm/deduplicate`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DeduplicationRequestToJSON(requestParameters['deduplicationRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DeduplicationResponseFromJSON(jsonValue));
    }

    /**
     * Run deduplication for integration instance
     */
    async runDeduplication(requestParameters: RunDeduplicationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeduplicationResponse> {
        const response = await this.runDeduplicationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Run full deduplication for all entities
     */
    async runFullDeduplicationRaw(requestParameters: RunFullDeduplicationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeduplicationResponse>> {
        if (requestParameters['sessionId'] == null) {
            throw new runtime.RequiredError(
                'sessionId',
                'Required parameter "sessionId" was null or undefined when calling runFullDeduplication().'
            );
        }

        if (requestParameters['fullDeduplicationRequest'] == null) {
            throw new runtime.RequiredError(
                'fullDeduplicationRequest',
                'Required parameter "fullDeduplicationRequest" was null or undefined when calling runFullDeduplication().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/mdm/deduplicate/full`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FullDeduplicationRequestToJSON(requestParameters['fullDeduplicationRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DeduplicationResponseFromJSON(jsonValue));
    }

    /**
     * Run full deduplication for all entities
     */
    async runFullDeduplication(requestParameters: RunFullDeduplicationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeduplicationResponse> {
        const response = await this.runFullDeduplicationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Run or dry-run controlled re-match after policy change (REQ-GOV-07)
     */
    async runMatchingPolicyRematchJobRaw(requestParameters: RunMatchingPolicyRematchJobRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MdmPolicyRematchJobResultDto>> {
        if (requestParameters['sessionId'] == null) {
            throw new runtime.RequiredError(
                'sessionId',
                'Required parameter "sessionId" was null or undefined when calling runMatchingPolicyRematchJob().'
            );
        }

        if (requestParameters['mdmPolicyRematchJobRequest'] == null) {
            throw new runtime.RequiredError(
                'mdmPolicyRematchJobRequest',
                'Required parameter "mdmPolicyRematchJobRequest" was null or undefined when calling runMatchingPolicyRematchJob().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/mdm/policies/rematch-job`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MdmPolicyRematchJobRequestToJSON(requestParameters['mdmPolicyRematchJobRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MdmPolicyRematchJobResultDtoFromJSON(jsonValue));
    }

    /**
     * Run or dry-run controlled re-match after policy change (REQ-GOV-07)
     */
    async runMatchingPolicyRematchJob(requestParameters: RunMatchingPolicyRematchJobRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MdmPolicyRematchJobResultDto> {
        const response = await this.runMatchingPolicyRematchJobRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Save draft MDM matching policy (prospective-only)
     */
    async saveMatchingPolicyRaw(requestParameters: SaveMatchingPolicyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MdmMatchingPolicyDetailDto>> {
        if (requestParameters['sessionId'] == null) {
            throw new runtime.RequiredError(
                'sessionId',
                'Required parameter "sessionId" was null or undefined when calling saveMatchingPolicy().'
            );
        }

        if (requestParameters['saveMdmMatchingPolicyRequest'] == null) {
            throw new runtime.RequiredError(
                'saveMdmMatchingPolicyRequest',
                'Required parameter "saveMdmMatchingPolicyRequest" was null or undefined when calling saveMatchingPolicy().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/mdm/policies`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SaveMdmMatchingPolicyRequestToJSON(requestParameters['saveMdmMatchingPolicyRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MdmMatchingPolicyDetailDtoFromJSON(jsonValue));
    }

    /**
     * Save draft MDM matching policy (prospective-only)
     */
    async saveMatchingPolicy(requestParameters: SaveMatchingPolicyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MdmMatchingPolicyDetailDto> {
        const response = await this.saveMatchingPolicyRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Search MDM source rows for match preview picker
     */
    async searchPreviewEntitiesRaw(requestParameters: SearchPreviewEntitiesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MdmPreviewEntitySearchResponse>> {
        if (requestParameters['sessionId'] == null) {
            throw new runtime.RequiredError(
                'sessionId',
                'Required parameter "sessionId" was null or undefined when calling searchPreviewEntities().'
            );
        }

        if (requestParameters['entityType'] == null) {
            throw new runtime.RequiredError(
                'entityType',
                'Required parameter "entityType" was null or undefined when calling searchPreviewEntities().'
            );
        }

        if (requestParameters['q'] == null) {
            throw new runtime.RequiredError(
                'q',
                'Required parameter "q" was null or undefined when calling searchPreviewEntities().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        if (requestParameters['entityType'] != null) {
            queryParameters['entityType'] = requestParameters['entityType'];
        }

        if (requestParameters['q'] != null) {
            queryParameters['q'] = requestParameters['q'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/mdm/match/preview/entities/search`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MdmPreviewEntitySearchResponseFromJSON(jsonValue));
    }

    /**
     * Search MDM source rows for match preview picker
     */
    async searchPreviewEntities(requestParameters: SearchPreviewEntitiesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MdmPreviewEntitySearchResponse> {
        const response = await this.searchPreviewEntitiesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Split a golden record into multiple records
     */
    async splitGoldenRecordRaw(requestParameters: SplitGoldenRecordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SplitResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling splitGoldenRecord().'
            );
        }

        if (requestParameters['sessionId'] == null) {
            throw new runtime.RequiredError(
                'sessionId',
                'Required parameter "sessionId" was null or undefined when calling splitGoldenRecord().'
            );
        }

        if (requestParameters['splitRequest'] == null) {
            throw new runtime.RequiredError(
                'splitRequest',
                'Required parameter "splitRequest" was null or undefined when calling splitGoldenRecord().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/mdm/golden-records/{id}/split`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SplitRequestToJSON(requestParameters['splitRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SplitResponseFromJSON(jsonValue));
    }

    /**
     * Split a golden record into multiple records
     */
    async splitGoldenRecord(requestParameters: SplitGoldenRecordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SplitResponse> {
        const response = await this.splitGoldenRecordRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Traverse container graph from host asset
     */
    async traverseContainerGraphFromHostRaw(requestParameters: TraverseContainerGraphFromHostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ContainerGraphTraversalResponse>> {
        if (requestParameters['sessionId'] == null) {
            throw new runtime.RequiredError(
                'sessionId',
                'Required parameter "sessionId" was null or undefined when calling traverseContainerGraphFromHost().'
            );
        }

        if (requestParameters['assetId'] == null) {
            throw new runtime.RequiredError(
                'assetId',
                'Required parameter "assetId" was null or undefined when calling traverseContainerGraphFromHost().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        if (requestParameters['assetId'] != null) {
            queryParameters['assetId'] = requestParameters['assetId'];
        }

        if (requestParameters['maxHops'] != null) {
            queryParameters['maxHops'] = requestParameters['maxHops'];
        }

        if (requestParameters['maxNodes'] != null) {
            queryParameters['maxNodes'] = requestParameters['maxNodes'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/mdm/containers/graph/from-host`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ContainerGraphTraversalResponseFromJSON(jsonValue));
    }

    /**
     * Traverse container graph from host asset
     */
    async traverseContainerGraphFromHost(requestParameters: TraverseContainerGraphFromHostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ContainerGraphTraversalResponse> {
        const response = await this.traverseContainerGraphFromHostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Traverse container graph from image digest
     */
    async traverseContainerGraphFromImageRaw(requestParameters: TraverseContainerGraphFromImageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ContainerGraphTraversalResponse>> {
        if (requestParameters['sessionId'] == null) {
            throw new runtime.RequiredError(
                'sessionId',
                'Required parameter "sessionId" was null or undefined when calling traverseContainerGraphFromImage().'
            );
        }

        if (requestParameters['imageDigest'] == null) {
            throw new runtime.RequiredError(
                'imageDigest',
                'Required parameter "imageDigest" was null or undefined when calling traverseContainerGraphFromImage().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        if (requestParameters['imageDigest'] != null) {
            queryParameters['imageDigest'] = requestParameters['imageDigest'];
        }

        if (requestParameters['maxHops'] != null) {
            queryParameters['maxHops'] = requestParameters['maxHops'];
        }

        if (requestParameters['maxNodes'] != null) {
            queryParameters['maxNodes'] = requestParameters['maxNodes'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/mdm/containers/graph/from-image`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ContainerGraphTraversalResponseFromJSON(jsonValue));
    }

    /**
     * Traverse container graph from image digest
     */
    async traverseContainerGraphFromImage(requestParameters: TraverseContainerGraphFromImageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ContainerGraphTraversalResponse> {
        const response = await this.traverseContainerGraphFromImageRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Traverse user–host graph from Account golden
     */
    async traverseUserHostGraphFromAccountRaw(requestParameters: TraverseUserHostGraphFromAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserHostGraphTraversalResponse>> {
        if (requestParameters['sessionId'] == null) {
            throw new runtime.RequiredError(
                'sessionId',
                'Required parameter "sessionId" was null or undefined when calling traverseUserHostGraphFromAccount().'
            );
        }

        if (requestParameters['accountGoldenId'] == null) {
            throw new runtime.RequiredError(
                'accountGoldenId',
                'Required parameter "accountGoldenId" was null or undefined when calling traverseUserHostGraphFromAccount().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        if (requestParameters['accountGoldenId'] != null) {
            queryParameters['accountGoldenId'] = requestParameters['accountGoldenId'];
        }

        if (requestParameters['windowDays'] != null) {
            queryParameters['windowDays'] = requestParameters['windowDays'];
        }

        if (requestParameters['maxNodes'] != null) {
            queryParameters['maxNodes'] = requestParameters['maxNodes'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/mdm/users/graph/from-account`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserHostGraphTraversalResponseFromJSON(jsonValue));
    }

    /**
     * Traverse user–host graph from Account golden
     */
    async traverseUserHostGraphFromAccount(requestParameters: TraverseUserHostGraphFromAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserHostGraphTraversalResponse> {
        const response = await this.traverseUserHostGraphFromAccountRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Traverse user–host graph from Person golden
     */
    async traverseUserHostGraphFromPersonRaw(requestParameters: TraverseUserHostGraphFromPersonRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserHostGraphTraversalResponse>> {
        if (requestParameters['sessionId'] == null) {
            throw new runtime.RequiredError(
                'sessionId',
                'Required parameter "sessionId" was null or undefined when calling traverseUserHostGraphFromPerson().'
            );
        }

        if (requestParameters['personGoldenId'] == null) {
            throw new runtime.RequiredError(
                'personGoldenId',
                'Required parameter "personGoldenId" was null or undefined when calling traverseUserHostGraphFromPerson().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        if (requestParameters['personGoldenId'] != null) {
            queryParameters['personGoldenId'] = requestParameters['personGoldenId'];
        }

        if (requestParameters['windowDays'] != null) {
            queryParameters['windowDays'] = requestParameters['windowDays'];
        }

        if (requestParameters['maxNodes'] != null) {
            queryParameters['maxNodes'] = requestParameters['maxNodes'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/mdm/users/graph/from-person`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserHostGraphTraversalResponseFromJSON(jsonValue));
    }

    /**
     * Traverse user–host graph from Person golden
     */
    async traverseUserHostGraphFromPerson(requestParameters: TraverseUserHostGraphFromPersonRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserHostGraphTraversalResponse> {
        const response = await this.traverseUserHostGraphFromPersonRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
